var baseFontSize = 16;
export var getRem = function getRem(value) {
  return value / baseFontSize;
};
export var rem = function rem(value) {
  return "".concat(value / baseFontSize, "rem");
};